import { Box, Card as MuiCard, CardContent as MuiCardContent, makeStyles, Typography, Divider as MuiDivider, withStyles, Button, TextField } from "@material-ui/core"
import { Color } from "@material-ui/lab";
import { spacing } from "@material-ui/system";
import { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import styled from "styled-components/macro";
import { AccessibilityUnit } from "../models/AccessibilityUnits";
import { AppStateType } from "../redux/reducers";
import { createA11yExtraInfo, deleteA11yExtraInfo, fetchA11yExtraInfo, updateA11yExtraInfo } from "../services/a11yesService";
import { Notification } from "./Notification";
import { useTranslation } from "react-i18next";

const Divider = styled(MuiDivider)(spacing);
const Card = styled(MuiCard)(spacing);
const CardContent = styled(MuiCardContent)`
  height: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding-bottom:0px;
`

const BoxTextField = styled(Box)`
  width: 100%;
  div:first-child {
    width: 100%;
  }
`

const useStyles = makeStyles((theme) => ({
    alert: {
        backgroundColor: "#354557",
        color: "#cfcfcf",
        "& .MuiAlert-icon": {
            display: "grid",
            placeItems: "center"
        }
    },
    delete: {
        color: theme.palette.error.dark
    },
}))

const StyledButton = withStyles({
    root: {
        border: '1px solid black',
        color: 'black',
        backgroundImage: 'linear-gradient(90deg, #84FAB0 0%, #8FEAFE 100%);'
    },
})(Button);

export const ExtraInfo = ({
    existingUnit,
}: {
    existingUnit: AccessibilityUnit | null
}) => {
    const user: any = useSelector((state: AppStateType) => state.authReducer.user)
    const [extraInfo, setExtraInfo] = useState("");
    const [existing, setExisting] = useState<any>(null);
    const [notify, setNotify] = useState<{
        isOpen: boolean;
        message: string;
        type: Color;
    }>(null!);
    const classes = useStyles();
    const { t } = useTranslation();

    useEffect(() => {
        (async function () {
            if (existingUnit && existingUnit.id) {
                const data = await fetchA11yExtraInfo({
                    accessibility_units__id: existingUnit.id
                }, user.token);
                if (data.count === 0) {
                    setExtraInfo("");
                    setExisting(null);
                } else {
                    setExisting(data.results[0]);
                    setExtraInfo(data.results[0].extra_info);
                }
            }
        }())

        setNotify(null!);
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [existingUnit]);

    const onSave = async () => {
        if (existingUnit && existingUnit.id) {
            if (existing) {
                if (extraInfo === "") {
                    await deleteA11yExtraInfo(existing.id, user.token);

                } else {
                    await updateA11yExtraInfo({
                        extra_info: extraInfo,
                    }, existing.id, user.token);
                }
            } else {
                const existing = await createA11yExtraInfo({
                    accessibility_units: [existingUnit.id as any],
                    extra_info: extraInfo,
                    language_code: "en"
                }, user.token);
                setExisting(existing);
            }
            if (extraInfo) {
                setNotify({
                    isOpen: true,
                    message: t("questionUnits_savedInfo"),
                    type: "success"
                });
            } else {
                setNotify({
                    isOpen: true,
                    message: t("questionUnits_removedInfo"),
                    type: "warning"
                });
            }
        }
    }
    const onDelete = async () => {
        if (existing) {
            await deleteA11yExtraInfo(existing.id, user.token);
            setExisting(null!);
        }
        setExtraInfo("");
        setNotify({
            isOpen: true,
            message: t("questionUnits_removedInfo"),
            type: "warning"
        });
    }
    return (
        <Card>
            <CardContent>
                <Typography variant="h6" gutterBottom>
                    {t("questionUnits_unitExtraInfo")}
                </Typography>
                <Divider my={4} />
                <BoxTextField mt={3}>
                    <TextField
                        label={t("questionUnits_unitExtraInfoLabel")}
                        InputLabelProps={{
                            shrink: true,
                        }}
                        value={extraInfo}
                        onChange={e => setExtraInfo(e.target.value)}
                        multiline
                        rows={4}
                        rowsMax={8}
                        placeholder={`${t("questionUnits_unitExtraInfoPlaceholder1")} ${!existing ? t("questionUnits_unitExtraInfoPlaceholder2") : ''}`}
                        variant="outlined"
                    />
                </BoxTextField>
                <Box mt={4} style={{ display: "flex", width: "100%" }}>
                    <Button disabled={!existing} onClick={onDelete} className={classes.delete}>
                        {t("questionUnits_unitExtraInfoDelete_button")}
                    </Button>
                    <div style={{ flex: 1 }}></div>
                    <StyledButton
                        onClick={onSave}
                        fullWidth
                        disabled={existingUnit ? false : true}
                        style={{
                            width: "auto",
                            color: !existingUnit ? '#929292' : 'black',
                            border: !existingUnit ? '1px solid #929292' : '1px solid black'
                        }}>
                        {t("questionUnits_unitExtraInfoSave_button")}
                    </StyledButton>
                </Box>
                {notify ? <Notification notify={notify} setNotify={setNotify} className={classes.alert} /> : null}
            </CardContent>
        </Card>
    )
}